<template>
  <div
    class="bb-settings-categories-project-step-item-percent"
    @click.stop="onEdit"
  >
    <input
      v-if="item.isEditPercent"
      class="bb-settings-categories-project-step-item-percent__field bb-input bb-input_border"
      :class="[item.errorPercent && 'bb-input_error']"
      type="number"
      v-autofocus="isFocus"
      :value="item.percent"
      @input="onChangeInput($event)"
      @click.stop
    >
    <span v-else>
      {{item.percent}}%
    </span>
  </div>
</template>

<script>
export default {
  name: 'ExpenseCategoriesListOfProjectStepItemPercent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    min: 0,
    max: 100,
    isFocus: false
  }),
  methods: {
    minMaxInput (newVal) {
      if (Number(newVal) > this.max) {
        this.$set(this.item, 'percent', this.max)
      } else if (Number(newVal) < this.min) {
        this.$set(this.item, 'percent', this.min)
      }
    },
    onChangeInput ({ target }) {
      const { value } = target
      this.$set(this.item, 'percent', Number(value))
      this.minMaxInput(value)
    },
    onEdit () {
      this.isFocus = true
      const { _id } = this.item
      this.$emit('onEdit')
      this.$set(this.item, 'isEditPercent', _id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bb-settings-categories-project-step-item-percent {
    font-size: 14px;
    line-height: 17px;
    text-align: end;

    &__field {
      height: 35px;
      width: 100%;
      padding: 8px 7px;
      font-weight: 500;
      transition: 0.3s;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProjectStep/ExpenseCategoriesListOfProjectStepItemPercent.vue